import Modal from '@acorn-portal/shared/src/components-v2/modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import ModalContentWrapper from '../../modal-content-wrapper';
import { useEffect } from 'react';
import useTrack from '@acorn-portal/shared/src/hooks/useTrack/useTrack';

interface ICancellationReasonHelperModal {
	open: boolean;
	onClose: () => void;
	stepNumber?: number;
}

const MODAL_NAME = 'cancellation_mta_change_modal';

const MtaModal = ({ open, onClose, stepNumber }: ICancellationReasonHelperModal) => {
	const { track } = useTrack();

	useEffect(() => {
		if (!open) return;
		track('cancellation_mta_change_modal_open', { name: MODAL_NAME, step_number: stepNumber });
	}, [open]);

	const onContinue = () => {
		track('cancellation_mta_change_modal_continue', { name: MODAL_NAME, step_number: stepNumber });
		onClose();
	};

	const onChangeCover = () => {
		track('cancellation_mta_change_modal_change_cover', { name: MODAL_NAME, step_number: stepNumber });
		onClose();
	};

	return (
		<Box>
			<Modal open={open} onClose={onContinue}>
				<ModalContentWrapper>
					<DialogTitle component='h2' variant='h5' sx={{ fontWeight: 700, m: 0, p: 0, textAlign: 'center' }}>
						Make a change instead
					</DialogTitle>
					<p style={{ textAlign: 'center' }}>
						You may be able to change your cover via the portal to reduce the costs of your insurance. This means you
						would not need to cancel your policy.
					</p>
					<Button
						variant='contained'
						onClick={onContinue}
						sx={{
							width: '100%',
						}}
					>
						Continue
					</Button>
					<Button
						onClick={onChangeCover}
						component={Link}
						to={ROUTE_PATHS.makeAChangeHome}
						variant='text'
						size='large'
						sx={{
							border: 'solid 1px',
							color: 'primary.dark',
							borderColor: 'primary.dark',
							px: '1rem',
							width: '100%',
							mt: '1em',
						}}
					>
						Change your cover
					</Button>
				</ModalContentWrapper>
			</Modal>
		</Box>
	);
};
export default MtaModal;
